module.exports = __webpack_public_path__ + "img/vertical_6_4_8017.acc3ae9c.png";